import { render, staticRenderFns } from "./ResellerSelector.vue?vue&type=template&id=1c2545f2"
import script from "./ResellerSelector.vue?vue&type=script&lang=js"
export * from "./ResellerSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports